// extracted by mini-css-extract-plugin
export default {"logo":"PoweredByHops_logo__-wUN0"};